import React from "react";
import shippedLogo from "../logos/shipped.png";
import { Link } from "react-router-dom";
function Shipped(props) {
  const ship = props.name && true;
  return ship ? (
    <div className="shipped">
      <div className="product-card">
        <img src={props.shippedItem.img} alt="" />
        <h4>{props.shippedItem.name}</h4>
        <h3>${(props.shippedItem.price * 0.8).toFixed(2)}</h3>
        <h4>Delivery Charges to Pakistan: ${props.shippedItem.delivery}</h4>
      </div>
      <div>
        <img src={shippedLogo} alt="" className="ship-img" />
        <h3>Your Item Will Be Shipped in 1 month. Be Patient </h3>
        <Link to="/help" className="btn-danger btn">
          Report an issue
        </Link>
        <Link to="/help" className="btn btn-link">
          Message the Owner
        </Link>
        <Link to="/help" className="btn btn-purple">
          Send Your Feedback!
        </Link>
      </div>
    </div>
  ) : (
    <div className="not-shipped">
      <h1>No Items Have Been Shipped</h1>
      <Link to="/products" className="btn btn-link">
        Add Products
      </Link>
    </div>
  );
}
export default Shipped;
